// extracted by mini-css-extract-plugin
export var container = "Accordion-module--container--3aUFW";
export var head = "Accordion-module--head--3uCTo";
export var body = "Accordion-module--body--33Xyp";
export var accordion = "Accordion-module--accordion--DEEeN";
export var content = "Accordion-module--content--1j4Ct";
export var tanned = "Accordion-module--tanned--3hgiU";